function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter80(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M76.6198 114.684C71.8318 114.684 67.4398 111.804 67.4398 106.908C67.4398 103.812 69.5638 101.76 71.5798 100.896C69.8518 99.9961 68.4838 98.2681 68.4838 95.9641C68.4838 91.7881 72.1918 89.0521 76.6198 89.0521C81.0478 89.0521 84.7558 91.7881 84.7558 95.9641C84.7558 98.2681 83.3878 99.9961 81.6598 100.896C83.6758 101.76 85.7998 103.812 85.7998 106.908C85.7998 111.804 81.4078 114.684 76.6198 114.684ZM76.6198 110.22C78.8878 110.22 80.5798 108.744 80.5798 106.692C80.5798 104.568 78.8878 103.164 76.6198 103.164C74.3518 103.164 72.6598 104.568 72.6598 106.692C72.6598 108.744 74.3518 110.22 76.6198 110.22ZM79.8958 96.2881C79.8958 94.5961 78.4558 93.4081 76.6198 93.4081C74.7838 93.4081 73.3438 94.5961 73.3438 96.2881C73.3438 98.0521 74.7838 99.2041 76.6198 99.2041C78.4558 99.2041 79.8958 98.0521 79.8958 96.2881Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6123 101.868C88.6123 95.1361 92.1763 89.0521 99.1963 89.0521C106.216 89.0521 109.78 95.1361 109.78 101.868C109.78 108.6 106.216 114.684 99.1963 114.684C92.1763 114.684 88.6123 108.6 88.6123 101.868ZM104.416 101.868C104.416 97.9441 102.832 94.0561 99.1963 94.0561C95.5603 94.0561 93.9763 97.9441 93.9763 101.868C93.9763 105.792 95.5603 109.68 99.1963 109.68C102.832 109.68 104.416 105.792 104.416 101.868Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82 95.1361C124.82 98.4841 122.048 101.076 118.628 101.076C115.208 101.076 112.472 98.4841 112.472 95.1361C112.472 91.7881 115.208 89.1961 118.628 89.1961C122.048 89.1961 124.82 91.7881 124.82 95.1361ZM118.628 97.6201C120.032 97.6201 121.04 96.5401 121.04 95.1361C121.04 93.7321 120.032 92.6521 118.628 92.6521C117.224 92.6521 116.216 93.7321 116.216 95.1361C116.216 96.5401 117.224 97.6201 118.628 97.6201ZM119.528 114.216H114.74L133.064 89.4841H137.852L119.528 114.216ZM133.928 114.504C130.508 114.504 127.772 111.912 127.772 108.564C127.772 105.216 130.508 102.624 133.928 102.624C137.384 102.624 140.12 105.216 140.12 108.564C140.12 111.912 137.384 114.504 133.928 114.504ZM133.928 111.048C135.332 111.048 136.376 109.968 136.376 108.564C136.376 107.16 135.332 106.08 133.928 106.08C132.524 106.08 131.516 107.16 131.516 108.564C131.516 109.968 132.524 111.048 133.928 111.048Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.929 11.0574C110.416 5.28247 106.122 0.149392 100.327 0.258042C82.0085 0.601533 64.0493 5.87691 48.3804 15.6197C29.7298 27.2165 15.3202 44.5233 7.29467 64.9664C-0.730905 85.4095 -1.94386 107.897 3.83617 129.085C9.6162 150.273 22.0805 169.029 39.3755 182.565C56.6705 196.1 77.8724 203.692 99.8283 204.212C121.784 204.731 143.321 198.15 161.237 185.447C179.153 172.744 192.49 154.598 199.265 133.707C204.957 116.156 205.762 97.4558 201.694 79.5912C200.407 73.9404 194.392 71.0053 188.904 72.8657C183.415 74.7261 180.546 80.6799 181.682 86.3629C184.389 99.9082 183.599 113.983 179.302 127.233C173.92 143.825 163.327 158.238 149.098 168.327C134.869 178.416 117.763 183.643 100.325 183.23C82.8863 182.818 66.0468 176.788 52.3104 166.037C38.5739 155.287 28.6742 140.39 24.0835 123.561C19.4927 106.733 20.4561 88.8726 26.8304 72.6358C33.2046 56.399 44.6493 42.6531 59.4624 33.4425C71.2914 26.0873 84.7638 21.9379 98.5628 21.3108C104.352 21.0478 109.442 16.8324 109.929 11.0574Z",
    fill: "url(#paint0_linear_29_426)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_426",
    x1: -12.1943,
    y1: 91.4637,
    x2: 228.364,
    y2: 92.3472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C",
    style: {
      stopColor: "#AA367C",
      stopColor: "color(display-p3 0.6667 0.2118 0.4863)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD",
    style: {
      stopColor: "#4A2FBD",
      stopColor: "color(display-p3 0.2902 0.1843 0.7412)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter80);
export default __webpack_public_path__ + "static/media/meter_80.92fb251c81070d21f1254e371ee5d2d0.svg";
export { ForwardRef as ReactComponent };